import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import z from 'zod/v4'
import { getBookingTransportationQueryOptions } from '@/queries/query'
import PreviewBusDetail from '@/components/my-booking/modals/PreviewBusDetail'

export const Route = createFileRoute(
  '/my-booking/$id/cancel/confirm/$transportationId/detail',
)({
  params: {
    parse: (params) => ({
      transportationId: z.string().trim().parse(params.transportationId),
    }),
    stringify: ({ transportationId }) => ({ transportationId }),
  },
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const transportationId = Route.useParams({
    select: (s) => s.transportationId,
  })
  const {
    data: {
      data: { booked_transportation },
    },
  } = useSuspenseQuery(getBookingTransportationQueryOptions(transportationId))

  return (
    <PreviewBusDetail
      isOpen
      bus={booked_transportation}
      onClose={() => router.history.back()}
    />
  )
}
